import React, { useState, useEffect, useMemo, useRef } from 'react'
import CAMHeader from "../../../components/Header/CAMHeader";
import CAMDrawer from "../../../components/LeftSideBar/CAMDrawer";
import InvestigatorContainer from "../../../components/contsiners/InvestigatorContainer";
import TabsNav from "../common/ProcessNav";
import { Box, Button } from "@mui/material";
import MultipleInput from "../../../components/Card/MultipleInput";
import Table from "./Table"
import TablePhase from "./TablePhase"
import TableLevel from "./TableLevel"
import Pagination from '../../../components/Pagination/index';
import Loader from '../../../components/Loader/loader';
import SnackBar from '../../../components/Snackbars/CustomizedSnackbars';
import AddParamter from './AddParamter';
import AddPhase from './AddPhase';
import AddTable from './AddTable';
import DynamicFilter from '../../../components/Fillter/DyanamicFillter';
import { useDispatch, useSelector } from "react-redux";
import * as uop from "../../../redux/parameter/actions";
import * as para from "../../../redux/parameter/actions";
import ConfirmationDialog from '../../../components/DialogBox/Confirmation';
import debounce from "lodash.debounce";
import { formatLocal } from '../../../utility';
import ExcelView from './ExcelView';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import FormulaBuilder from "../../../components/FormulaBuilder/FormulaBuilder";
import ParameterService from "../../../services/parameterService";
import { hasPermission } from "../../../utils/permissions";
import { normalizeFormulaVariables } from "../../../utils/parameterUtility";
import {
  CONFIGURATION_PERMISSIONS,
  PERMISSION_MODULES,
} from "../../../constants/permissions";
import "./parameter.scss";

const parameterService = new ParameterService();

const getSourceParameterList = (response) => {
    const payload = response?.data?.data ?? response?.data ?? [];
    if (Array.isArray(payload)) return payload;
    return payload?.parameters ?? payload?.source_parameters ?? payload?.results ?? [];
};

const getFormulaDisplayValue = (expression, parameters) => {
    if (!expression) return "";

    const displayParameters = parameters
        .map((parameter) => ({
            id: parameter?.parameter_id ?? parameter?.parameter_code ?? parameter?.id,
            name: parameter?.parameter_name ?? parameter?.name ?? parameter?.label,
        }))
        .filter((parameter) => parameter.id && parameter.name)
        .sort((a, b) => String(b.id).length - String(a.id).length);

    return displayParameters.reduce((displayExpression, parameter) => {
        return displayExpression.replaceAll(String(parameter.id), String(parameter.name));
    }, String(expression));
};

const ParamterList = () => {
    const canAddParameter = hasPermission(PERMISSION_MODULES.CONFIGURATION, CONFIGURATION_PERMISSIONS.ADD_PARAMETER);
    const canUpdateParameter = hasPermission(PERMISSION_MODULES.CONFIGURATION, CONFIGURATION_PERMISSIONS.UPDATE_PARAMETER);
    const canDeleteParameter = hasPermission(PERMISSION_MODULES.CONFIGURATION, CONFIGURATION_PERMISSIONS.DELETE_PARAMETER);
    const canRestoreParameter = hasPermission(PERMISSION_MODULES.CONFIGURATION, CONFIGURATION_PERMISSIONS.RESTORE_PARAMETER);
    const canApproveParameter = hasPermission(PERMISSION_MODULES.CONFIGURATION, CONFIGURATION_PERMISSIONS.APPROVE_PARAMETER);
    const canViewParameter = hasPermission(PERMISSION_MODULES.CONFIGURATION, CONFIGURATION_PERMISSIONS.VIEW_PARAMETER_LIST);
    const canAddPhase = hasPermission(PERMISSION_MODULES.CONFIGURATION, CONFIGURATION_PERMISSIONS.ADD_PARAMETER_PHASE);
    const canDeletePhase = hasPermission(PERMISSION_MODULES.CONFIGURATION, CONFIGURATION_PERMISSIONS.DELETE_PARAMETER_PHASE);
    const canAddTable = hasPermission(PERMISSION_MODULES.CONFIGURATION, CONFIGURATION_PERMISSIONS.ADD_PARAMETER_TABLE);
    const canDeleteTable = hasPermission(PERMISSION_MODULES.CONFIGURATION, CONFIGURATION_PERMISSIONS.DELETE_PARAMETER_TABLE);
    const canReorderParameters = hasPermission(PERMISSION_MODULES.CONFIGURATION, CONFIGURATION_PERMISSIONS.REORDER_PARAMETERS);
    const parameterMenuOptions = [
        canUpdateParameter && "Update",
        canDeleteParameter && "Delete",
        canRestoreParameter && "Restore",
    ].filter(Boolean);
    const parameterTabs = [
        (canViewParameter || canAddParameter || canUpdateParameter) && { label: "Parameter", value: 0 },
        (canAddPhase || canDeletePhase) && { label: "Parameter Phase", value: 1 },
        (canAddTable || canDeleteTable) && { label: "Parameter Table", value: 2 },
    ].filter(Boolean);

    const [page, setPage] = useState(1);
    const [filterOpen, setFilterOpen] = useState(false);
    const [openDailog, setOpenDailog] = useState(false);
    const [openExcelTemplate, setOpenExcelTemplate] = useState(false);
    const [openTableDailog, setOpenTableDailog] = useState(false);
    const [openRestoreDailog, setOpenRestoreDailog] = useState(false);
    const [openApproveDailog, setOpenApproveDailog] = useState(false);
    const [openPhaseDailog, setOpenPhaseDailog] = useState(false);
    const userName = localStorage.getItem('userName');
    const [tabValue, setTabValue] = useState(parameterTabs[0]?.value ?? 0);
    const [parameterData, setParameterData] = useState({
        parameter_id: '',
        created_by: userName,
        updated_by: userName
    });
    const [phaseData, setphaseData] = useState({
        phase_name: '',
        user: userName
    });
    const [tableData, setTableData] = useState({
        table_id: '',
        table_name: '',
        user: userName
    });
    const [snack, setSnack] = useState({
        open: false,
        message: "",
        severity: "success",
    });
    const [openParameter, setOpenParameter] = useState(false);
    const [openPhase, setOpenPhase] = useState(false);
    const [openTable, setOpenTable] = useState(false);
    const [selectedRow, setSelectedRow] = useState();
    const [selectedUnitOpid, setSelectedUnitOpid] = useState();
    const rowsPerPage = 50;
    const [addErrors, setAddErrors] = useState();
    const dispatch = useDispatch();
    const process = useSelector((state) => state?.process);
    const [debouncedSearch, setDebouncedSearch] = useState();
    const [selectedOption, setSelectedOption] = useState('add_parameter');
    const [search, setSearch] = useState();
    const [filters, setFilters] = useState({
        from_date: "",
        to_date: "",
    });
    const filterConfig = [
        {
            key: "from_date",
            label: "Created Date",
            type: "dateRange",
            fromKey: "from_date",
            toKey: "to_date",
        },
    ]
    const multiOptions = [
        canAddParameter && { label: "Add Parameter", value: "add_parameter" },
        canAddPhase && { label: "Add Phase", value: "add_phase" },
        // { label: "QQ Chart", value: "qq_chart" },
        canAddTable && { label: "Add Table Level", value: "add_table" },
    ].filter(Boolean);
    const [formulaOpen, setFormulaOpen] = useState(false);
    const [formulaParameters, setFormulaParameters] = useState([]);
    const [formulaParametersLoading, setFormulaParametersLoading] = useState(false);
    const [formulaParametersError, setFormulaParametersError] = useState("");
    const loadedFormulaUnitOpIdRef = useRef(null);
    const formulaDisplayValue = useMemo(
        () => getFormulaDisplayValue(parameterData?.formula_expression, formulaParameters),
        [parameterData?.formula_expression, formulaParameters]
    );

    useEffect(() => {
        if (parameterData?.source_system !== "Derived" || !parameterData?.unit_op_id) {
            setFormulaParameters([]);
            setFormulaParametersError("");
            setFormulaParametersLoading(false);
            loadedFormulaUnitOpIdRef.current = null;
            return;
        }

        const unitOpId = parameterData.unit_op_id;
        const unitOperationChanged = loadedFormulaUnitOpIdRef.current !== unitOpId;
        if (!formulaOpen && !unitOperationChanged) return;

        let isCurrentRequest = true;
        if (unitOperationChanged) setFormulaParameters([]);
        setFormulaParametersLoading(true);
        setFormulaParametersError("");

        parameterService.getDerivedFormulaSourceParameters(unitOpId)
            .then((response) => {
                if (!isCurrentRequest) return;
                setFormulaParameters(getSourceParameterList(response));
                loadedFormulaUnitOpIdRef.current = unitOpId;
            })
            .catch((error) => {
                if (!isCurrentRequest) return;
                setFormulaParameters([]);
                setFormulaParametersError(
                    error?.response?.data?.error || "Unable to load parameters for the selected unit operation."
                );
            })
            .finally(() => {
                if (isCurrentRequest) setFormulaParametersLoading(false);
            });

        return () => {
            isCurrentRequest = false;
        };
    }, [formulaOpen, parameterData?.source_system, parameterData?.unit_op_id]);

    const handleReset = () => {
        setFilters({
            from_date: "",
            to_date: "",
        });
    }

    const handlePageChange = (event, value) => {
        setPage(value);
        if (tabValue === 0) getParaListCall(value);
        if (tabValue === 1) getPhaseListCall(value);
        if (tabValue === 2) getTableListCall(value);
    };

    const handleChange = (field, value) => {
        setFilters((prev) => ({ ...prev, [field]: value }));
    };

    const debouncedSetValue = useMemo(
        () =>
            debounce((val) => {
                setDebouncedSearch(val);
            }, 700),
        []
    );

    const handleSearch = (e) => {
        setSearch(e.target.value);
        debouncedSetValue(e.target.value);
    };

    const validateAddErrors = (isRequired) => {
        setAddErrors({});
        const newErrors = {};
        if (!parameterData.parameter_name) {
            newErrors.parameter_name = "Required";
        } else {
            const regex = /[\/\\:*?"<>|\[\]]/;

            if (regex.test(parameterData.parameter_name)) {
                newErrors.parameter_name =
                    "Special characters are not allowed";
            }
        }
        if (!parameterData.unit_op_id) newErrors.unit_op_id = "Required";
        if (!parameterData.source_system) newErrors.source_system = "Required";
        if (parameterData.source_system === "Derived" && !parameterData.formula_expression) {
            newErrors.formula = "Required";
        }
        if (!parameterData.data_type) newErrors.data_type = "Required";
        // if (!parameterData.site_id) newErrors.site_id = "Required";
        setAddErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const validatePhaseErrors = (isRequired) => {
        setAddErrors({});
        const newErrors = {};
        if (!phaseData.phase_name) {
            newErrors.phase_name = "Required";
        } else {
            const regex = /[\/\\:*?"<>|\[\]]/;

            if (regex.test(phaseData.phase_name)) {
                newErrors.phase_name =
                    "Special characters are not allowed";
            }
        }

        setAddErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const validateTableErrors = (isRequired) => {
        setAddErrors({});
        const newErrors = {};
        if (!tableData.table_name) {
            newErrors.table_name = "Required";
        } else {
            const regex = /[\/\\:*?"<>|\[\]]/;

            if (regex.test(tableData.table_name)) {
                newErrors.table_name =
                    "Special characters are not allowed";
            }
        }

        setAddErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const handleOnChange = (e) => {
        const { name, value } = e.target;
        let newValue;
        if (typeof value === "string") {
            newValue = value?.trim() === "" ? null : value;
        } else {
            newValue = value === "" ? null : value;
        }

        if (selectedOption === 'add_phase') setphaseData((prev) => ({ ...prev, [name]: newValue }));
        if (selectedOption === 'add_table') setTableData((prev) => ({ ...prev, [name]: newValue }));
        if (selectedOption === 'add_parameter') {
            setParameterData((prev) => ({
                ...prev,
                [name]: newValue,
                ...(name === "source_system" && newValue === "Derived"
                    ? { data_type: "numeric", table_level_name: null }
                    : {}),
            }));
        }
    }

    useEffect(() => {
        if (
            parameterData?.source_system === "Derived" &&
            (parameterData?.data_type !== "numeric" || parameterData?.table_level_name)
        ) {
            setParameterData((prev) => ({
                ...prev,
                data_type: "numeric",
                table_level_name: null,
            }));
        }
    }, [parameterData?.source_system, parameterData?.data_type, parameterData?.table_level_name]);

    const handleAddPhase = async (e) => {
        e.preventDefault();
        if (selectedRow || !canAddPhase) return;
        if (!validatePhaseErrors(false)) return;
        if (selectedRow) {
            try {
                const res = await dispatch(uop.UpdatePhase(phaseData));
                setSnack({
                    open: true,
                    message: res.data.message || "Updated successfully. Please review and approve.",
                    severity: "success"
                });
                setOpenPhase(false)
                dispatch(uop.getParaMeta())
                getPhaseListCall(1)
            } catch (error) {
                setSnack({
                    open: true,
                    message: error.message || "Something went wrong",
                    severity: "error"
                });
            }
        } else {
            try {
                const res = await dispatch(uop.AddPhase(phaseData));
                setSnack({
                    open: true,
                    message: res.data.message || "Added successfully. Please review and approve.",
                    severity: "success"
                });
                setOpenPhase(false)
                dispatch(uop.getParaMeta())
                getPhaseListCall(1)
            } catch (error) {

                setSnack({
                    open: true,
                    message: error.response?.data?.error || "Something went wrong",
                    severity: "error"
                });
            }
        }
    };

    const handleAddTable = async (e) => {
        e.preventDefault();
        if (selectedRow || !canAddTable) return;
        if (!validateTableErrors(false)) return;
        if (selectedRow) {
            try {
                const res = await dispatch(uop.UpdateTableLevel(tableData));
                setSnack({
                    open: true,
                    message: res.data.message || "Updated successfully. Please review and approve.",
                    severity: "success"
                });
                setOpenTable(false)
                getTableListCall(1)
                dispatch(uop.getParaMeta())
            } catch (error) {
                setSnack({
                    open: true,
                    message: error.response?.data?.message || "Something went wrong",
                    severity: "error"
                });
            }
        } else {
            try {
                const res = await dispatch(uop.AddTableLevel(tableData));
                setSnack({
                    open: true,
                    message: res.data.message || "Added successfully. Please review and approve.",
                    severity: "success"
                });
                setOpenTable(false)
                getTableListCall(1);
                dispatch(uop.getParaMeta())
            } catch (error) {
                setSnack({
                    open: true,
                    message: error.response?.data?.error || "Something went wrong",
                    severity: "error"
                });
            }
        }
    };

    const handleAddSubmit = async (e) => {
        e.preventDefault();
        if ((parameterData?.parameter_id && !canUpdateParameter) || (!parameterData?.parameter_id && !canAddParameter)) return;
        if (!validateAddErrors(false)) return;
        if (parameterData?.parameter_id) {
            try {
                const updatePayload = {
                    parameter_id: parameterData.parameter_id,
                    parameter_name: parameterData.parameter_name,
                    is_required: parameterData.is_required,
                    source_system: parameterData.source_system,
                    unit_of_measure: parameterData.unit_of_measure,
                    parameter_class: parameterData.parameter_class,
                    data_type: parameterData.source_system === "Derived"
                        ? "numeric"
                        : parameterData.data_type,
                    formula_expression: parameterData.formula_expression,
                    formula_variables: normalizeFormulaVariables(parameterData.formula_variables),
                    updated_by: parameterData.updated_by || userName,
                    phase_name: parameterData.phase_name || "",
                    ...(parameterData.source_system === "Data Entry"
                        ? {
                            table_level_name: parameterData.table_level_name || "",
                        }
                        : {}),
                };
                const res = await dispatch(para.UpdatePara(updatePayload));
                setSnack({
                    open: true,
                    message: res.data.message || "Updated successfully. Please review and approve.",
                    severity: "success"
                });
                setOpenParameter(false)
                getParaListCall(page)
            } catch (error) {
                setSnack({
                    open: true,
                    message: error.response?.data?.error || "Something went wrong",
                    severity: "error"
                });
            }
        } else {
            try {
                const res = await dispatch(uop.AddParameter(parameterData));
                setSnack({
                    open: true,
                    message: res?.data?.message || "Added successfully. Please review and approve.",
                    severity: "success"
                });

                setOpenParameter(false)
                getParaListCall(page)

            } catch (error) {
                setSnack({
                    open: true,
                    message: error?.response?.data?.error || "Something went wrong",
                    severity: "error"
                });
            }
        }
    };

    const handleReorderColumn = async (data) => {
        if (!canReorderParameters) return;
        try {
            const res = await dispatch(para.reOrderColumn(data));
            setSnack({
                open: true,
                message: res.data.message || "Updated successfully. Please review and approve.",
                severity: "success"
            });
            // setOpenParameter(false)
            // getParaListCall(page)
        } catch (error) {
            setSnack({
                open: true,
                message: error.response?.data?.error || "Something went wrong",
                severity: "error"
            });
        }

    };

    const handleReorderSheet = async (e) => {
        if (!canReorderParameters) return;
        e.preventDefault();
        try {
            const res = await dispatch(para.reOrderSheet(parameterData));
            setSnack({
                open: true,
                message: res.data.message || "Updated successfully. Please review and approve.",
                severity: "success"
            });
            // setOpenParameter(false)
            // getParaListCall(page)
        } catch (error) {
            setSnack({
                open: true,
                message: error.response?.data?.error || "Something went wrong",
                severity: "error"
            });
        }

    };

    const handleDeletePhase = async () => {
        if (!canDeletePhase || !selectedRow?.phase_id) return;
        try {
            const res = await dispatch(uop.deletePhase(selectedRow));
            setSnack({
                open: true,
                message: res.data.message || "Updated successfully. Please review and approve.",
                severity: "success"
            });
            setOpenPhaseDailog(false)
            getPhaseListCall(page)
            dispatch(uop.getParaMeta())
        } catch (error) {
            setSnack({
                open: true,
                message: error.response?.data?.error || "Something went wrong",
                severity: "error"
            });
        }
    }

    const handleDeleteTable = async () => {
        if (!canDeleteTable || !selectedRow?.table_id) return;
        try {
            const res = await dispatch(uop.deleteTableLevel(selectedRow));
            setSnack({
                open: true,
                message: res.data.message || "Updated successfully. Please review and approve.",
                severity: "success"
            });
            setOpenTableDailog(false)
            getTableListCall(page)
        } catch (error) {
            setSnack({
                open: true,
                message: error.response?.data?.error || "Something went wrong",
                severity: "error"
            });
        }
    }

    const handleRestoreTable = async () => {
        if (!canRestoreParameter || !selectedRow?.param?.parameter_id) return;

        try {
            const res = await dispatch(uop.restoreParameter({ parameter_id: selectedRow.param.parameter_id, user: userName }));
            setSnack({
                open: true,
                message: res.data.message || "Restored successfully",
                severity: "success"
            });
            setOpenRestoreDailog(false)
            getParaListCall(page)
        } catch (error) {
            setSnack({
                open: true,
                message: error.response?.data?.error || "Something went wrong",
                severity: "error"
            });
        }
    }

    const handleApprovePara = async () => {
        if (!canApproveParameter || !selectedRow?.unit_op_id) return;
        try {
            const res = await dispatch(uop.approveParameter({
                unit_op_id: selectedRow.unit_op_id,
                approved_by: userName
            }));
            setSnack({
                open: true,
                message: res.data.message || "Approved successfully",
                severity: "success"
            });
            setOpenApproveDailog(false)
            getParaListCall(page)
        } catch (error) {
            setSnack({
                open: true,
                message: error.response?.data?.error || "Something went wrong",
                severity: "error"
            });
        }
    }

    const getParaListCall = (page) => {
        const data = {
            page: page,
            page_size: rowsPerPage
        }
        if (search) data.search = debouncedSearch;
        if (filters.from_date) data.from_date = formatLocal(filters.from_date);
        if (filters.to_date) data.to_date = formatLocal(filters.to_date);
        dispatch(para.getParaList(data))
    }

    const getTableListCall = (page) => {
        const data = {
            page: page,
            page_size: rowsPerPage
        }
        if (search) data.search = debouncedSearch;
        if (filters.from_date) data.from_date = formatLocal(filters.from_date);
        if (filters.to_date) data.to_date = formatLocal(filters.to_date);
        dispatch(uop.getTableList(data))
    }

    const getPhaseListCall = (page) => {
        const data = {
            page: page,
            page_size: rowsPerPage
        }
        if (search) data.search = debouncedSearch;
        if (filters.from_date) data.from_date = formatLocal(filters.from_date);
        if (filters.to_date) data.to_date = formatLocal(filters.to_date);
        dispatch(uop.getPhaseList(data))
    }

    // useEffect(() => {
    //     if (tabValue === 0) getParaListCall(page);
    //     if (tabValue === 1) getTableListCall(page);
    //     if (tabValue === 2) getPhaseListCall(page);
    // }, [page])

    const handleSetSelection = (option) => {
        if (!multiOptions.some((item) => item.value === option)) return;
        setSelectedOption(option)
        setAddErrors({})
        setSelectedRow('')
        if (option === 'add_phase') {
            setphaseData({
                phase_name: '',
                user: userName
            });
            setOpenPhase(true)
        };
        if (option === 'add_table') {
            setOpenTable(true);
            setTableData({
                table_id: '',
                table_name: '',
                user: userName
            })
        };
        if (option === 'add_parameter') {
            setOpenParameter(true);
            setParameterData({
                parameter_id: '',
                created_by: userName,
                updated_by: userName
            })
        };
    }

    useEffect(() => {
        setPage(1)
        if (tabValue === 0) getParaListCall(1);
        if (tabValue === 1) getPhaseListCall(1);
        if (tabValue === 2) getTableListCall(1);
    }, [tabValue, debouncedSearch])

    // useEffect(() => {
    //     setPage(1)
    //     if (tabValue === 0) getParaListCall(1);
    //     if (tabValue === 1) getPhaseListCall(1);
    //     if (tabValue === 2) getTableListCall(1);
    // }, [debouncedSearch])

    useEffect(() => {
        dispatch(uop.getParaMeta())
    }, [])

    const handleDelete = async () => {
        if (!canDeleteParameter || !selectedRow?.param?.parameter_id) return;

        try {
            const res = await dispatch(para.DeletePara({ parameter_id: selectedRow.param.parameter_id, deleted_by: userName }));
            setSnack({
                open: true,
                message: res.data.message || "Deleted successfully",
                severity: "success"
            });
            setOpenDailog(false);
            getParaListCall(page)

        } catch (error) {
            setSnack({
                open: true,
                message: error?.response?.data?.error || error?.message || "Something went wrong",
                severity: "error"
            });
        }

    }

    const handleGenerate = () => {
        getParaListCall(1)
    }

    const handleAddUop = () => {
        setAddErrors({})
        setOpenParameter(true)
        parameterData({
            step_name: '',
            site_id: '',
            product_id: '',
            user: userName
        })
        setSelectedRow('')
    }

    const handleMenuOption = (option, row) => {
        if (option === 'delete') {
            if (!canDeleteParameter) return;
            setSelectedRow(row)
            setOpenDailog(true);
        } else if (option === 'restore') {
            if (!canRestoreParameter) return;
            setSelectedRow(row)
            setOpenRestoreDailog(true);
        } else {
            if (!canUpdateParameter) return;
            setAddErrors({});
            setSelectedRow(row)
            setParameterData({
                parameter_id: row.param.parameter_id,
                unit_op_id: row.row.unit_op_id,
                unit_op_name: row.row.unit_op_name,
                product_name: row.row.product_name,
                site_name: row.row.site_name,
                phase_name: row.param.phase,
                table_level_name: row.param.table_level,
                parameter_name: row.param.parameter_name,
                description: row.param.description,
                notes: row.param.notes,
                unit_of_measure: row.param.unit_of_measure,
                parameter_class: row.param.parameter_class,
                data_type: row.param.data_type,
                source_system: row.param.source_system,
                formula_expression: row.param.formula_expression ?? row.param.formula,
                formula_variables: normalizeFormulaVariables(row.param.formula_variables),
                is_required: row.param.is_required,
                created_by: userName,
                updated_by: userName
            })
            setOpenParameter(true)
        }
    }

    const handlePhaseMenuOption = (option, row) => {
        if (!canDeletePhase) return;
        setSelectedRow({ phase_id: row.id, user: userName })
        if (option === 'Delete') {
            setOpenPhaseDailog(true);
        }
    }
    const handleTableMenuOption = (option, row) => {
        if (!canDeleteTable) return;
        setSelectedRow({ table_id: row.id, user: userName })
        if (option === 'Delete') {
            setOpenTableDailog(true);
        }
    }

    const handleTableLevel = (row) => {
        // console.log(row, 'table level')
    }

    const getTotalPerPage = () => {
        if (tabValue === 0) return process?.paraList?.data?.total / rowsPerPage
        if (tabValue === 1) return process?.phaseList?.data?.total / rowsPerPage
        if (tabValue === 2) return process?.tableList?.data?.total / rowsPerPage
    }

    const handleUnitOp = (row) => {
        if (!canReorderParameters) return;
        setSelectedUnitOpid(row.unit_op_id)
        setOpenExcelTemplate(true)
    }

    const handleParaApprove = (row) => {
        if (!canApproveParameter) return;
        setSelectedRow(row)
        setOpenApproveDailog(true)
    }

    return (
        <> <CAMHeader />
            <CAMDrawer />
            <InvestigatorContainer>  <TabsNav />
                {openExcelTemplate ?
                    <>
                        <Box sx={{ mt: 1, pt: 1, p: 1, borderTop: '1px solid #D5D7DA' }}>
                            <Button
                                startIcon={<ArrowBackIcon />}
                                sx={{
                                    textTransform: "none",
                                    borderRadius: "20px !important",
                                    paddingX: 2,
                                    paddingY: 0.2,
                                    backgroundColor: "#E9EAEB",
                                    color: "Black",
                                }}
                                onClick={() => setOpenExcelTemplate(false)}
                            >
                                Back
                            </Button></Box>
                        <ExcelView selectedUnitOpid={selectedUnitOpid} canReorder={canReorderParameters} /></> :
                    <>
                        <Box sx={{ borderTop: "1px solid #e0e0e0" }}>
                            <MultipleInput
                                text={'Process List'}
                                // buttonText={"Add Unit Operation"}
                                popupFilter={true}
                                onButtonClick={handleAddUop}
                                setOption={handleSetSelection}
                                selectedOption={selectedOption}
                                placeholder='Search by name'
                                // handleChildClick={handleChildClick}
                                // handleClick={handleClick}
                                // handleMenuOptionCallBack={handleMenuOptionCallBack}
                                // filterOptionsGroup1={group1}
                                // filterOptionsGroup2={group2}
                                // selectedFilters={selectedFilters}
                                // handleCheckboxChange={handleCheckboxChange}
                                isMultiOptinButton={multiOptions.length > 0}
                                // isAuditLogs={true}
                                handleSearch={handleSearch}
                                search={search}
                                showTab={true}
                                tabs={parameterTabs}
                                // viewAuditLogs={viewAuditLogs}
                                // auditText={"Audit Trail"}
                                // viewLogs={viewLogs}
                                // popupFilter={true}
                                handlePopupFilter={() => setFilterOpen(true)}
                                // onBackClick={() => setViewLogs(false)}
                                options={multiOptions}
                                tabValue={tabValue}
                                setTabValue={setTabValue}
                            />
                        </Box>
                        {snack?.open && (
                            <SnackBar
                                className="popup"
                                handleClose={() => {
                                    setSnack({
                                        open: false,
                                        message: "",
                                        severity: "",
                                    });
                                }}
                                severity={snack.severity}
                                state={snack?.open}
                                text={snack?.message}
                            />
                        )}
                        <Box>
                            <AddParamter
                                open={openParameter}
                                formData={parameterData}
                                onChange={handleOnChange}
                                onClose={() => {
                                    setAddErrors({});
                                    setOpenParameter(false);
                                }}
                                errors={addErrors}
                                handleSubmit={handleAddSubmit}
                                dropdownOption={process}
                                setFormulaOpen={setFormulaOpen}
                                formulaOpen={formulaOpen}
                                formulaDisplayValue={formulaDisplayValue}

                            />
                            {formulaOpen && (
                                <FormulaBuilder
                                    open={formulaOpen}
                                    handleClose={() => setFormulaOpen(false)}
                                    sourceParameters={formulaParameters}
                                    sourceParametersLoading={formulaParametersLoading}
                                    sourceParametersError={formulaParametersError}
                                    initialFormulaExpression={parameterData?.formula_expression}
                                    initialFormulaVariables={parameterData?.formula_variables}
                                    parameterName={parameterData?.parameter_name}
                                    onSubmit={({ formulaExpression, formulaVariables }) => {
                                        setParameterData((prev) => ({
                                            ...prev,
                                            formula_expression: formulaExpression,
                                            formula_variables: formulaVariables,
                                        }));
                                        setAddErrors((prev) => ({ ...prev, formula: undefined }));
                                        setFormulaOpen(false);
                                    }}
                                />
                            )}
                            <AddPhase
                                open={openPhase}
                                formData={phaseData}
                                onChange={handleOnChange}
                                onClose={() => {
                                    setAddErrors({});
                                    setOpenPhase(false);
                                }}
                                errors={addErrors}
                                handleSubmit={handleAddPhase}
                                dropdownOption={process}

                            />
                            <AddTable
                                open={openTable}
                                formData={tableData}
                                onChange={handleOnChange}
                                onClose={() => {
                                    setAddErrors({});
                                    setOpenTable(false);
                                }}
                                errors={addErrors}
                                handleSubmit={handleAddTable}
                                dropdownOption={process}

                            />
                        </Box>
                        <DynamicFilter
                            open={filterOpen}
                            onClose={() => setFilterOpen(false)}
                            filterValues={filters}
                            onReset={handleReset}
                            onGenerate={handleGenerate}
                            // data={auditLogs || []}
                            onChange={handleChange}
                            isStatusVisible={false}
                            filterConfig={filterConfig}
                        />

                        <Box width="100%" className="parameter-table">
                            {canDeleteParameter && <ConfirmationDialog
                                open={openDailog}
                                title="Confirm Deletion"
                                message="Do you really want to delete this parameter?"
                                onConfirm={handleDelete}
                                onCancel={() => setOpenDailog(false)}
                                loading={process?.deleteProcess?.loading}
                            />}
                            {canDeletePhase && <ConfirmationDialog
                                open={openPhaseDailog}
                                title="Confirm Deletion"
                                message="Do you really want to delete this Phase?"
                                onConfirm={handleDeletePhase}
                                onCancel={() => setOpenPhaseDailog(false)}
                                loading={process?.deletePhase?.loading}
                            />}
                            {canDeleteTable && <ConfirmationDialog
                                open={openTableDailog}
                                title="Confirm Deletion"
                                message="Do you really want to delete this Table?"
                                onConfirm={handleDeleteTable}
                                onCancel={() => setOpenTableDailog(false)}
                                loading={process?.deleteTable?.loading}

                            />}
                            {canRestoreParameter && <ConfirmationDialog
                                open={openRestoreDailog}
                                title="Confirm Restoration"
                                message="Do you really want to restore this Parameter?"
                                onConfirm={handleRestoreTable}
                                onCancel={() => setOpenRestoreDailog(false)}
                                text='Restore'
                                loading={process?.restore?.loading}
                            />}
                            {canApproveParameter && <ConfirmationDialog
                                open={openApproveDailog}
                                title="Confirm Approval"
                                message="Are you sure you want to approve this parameter? Please confirm that the Excel sheet and parameter order have been verified."
                                warningMessage="Any future changes to this template will also be reflected in all batches copied from it."
                                onConfirm={handleApprovePara}
                                onCancel={() => setOpenApproveDailog(false)}
                                text='Approve'
                                loading={process?.approveParameter?.loading}
                            />}
                            {tabValue === 0 && <Table data={process.paraList || []} onVisibilityClick={canReorderParameters ? handleUnitOp : undefined} moreOption={parameterMenuOptions} handleMenuOption={handleMenuOption} handleTableLevel={handleTableLevel} handleReorderColumn={canReorderParameters ? handleReorderColumn : undefined} handleApprove={canApproveParameter ? handleParaApprove : undefined} />}
                            {tabValue === 1 && <TablePhase data={process.phaseList || []} moreOption={canDeletePhase ? ["Delete"] : []} handleMenuOption={handlePhaseMenuOption} handleTableLevel={handleTableLevel} />}
                            {tabValue === 2 && <TableLevel data={process.tableList || []} moreOption={canDeleteTable ? ["Delete"] : []} handleMenuOption={handleTableMenuOption} handleTableLevel={handleTableLevel} />}
                            {process?.paraList?.loading && <Loader />}
                            {process?.phaseList?.loading && <Loader />}
                            {process?.tableList?.loading && <Loader />}
                            <Pagination
                                count={getTotalPerPage()}
                                page={page}
                                onChange={handlePageChange}
                            />
                        </Box>
                    </>}
            </InvestigatorContainer>
        </>
    )
}

export default ParamterList
